import { t } from "@web-monorepo/i18n/macro";
import { getImageSrc } from "@web-monorepo/static-assets";
import createKeyducer from "src/infra/createKeducer";
import { AppMetadata } from "src/pods/toolkitData/components/EditableSetup";

const icon = getImageSrc("toolkit/src/pods/timer/assets/logo.svg");

export const appMetadataTimer = (): AppMetadata => ({
  href: "timer",
  title: t`Timer`,
  variant: "timer",
  icon,
});

export type Timer = {
  seconds?: number;
  startTime?: number | null;
  endTime?: number | null;
  remainingTime?: number | null;
  increment?: number | null;
  reset?: boolean;
};

export function normalizeTimer(time: Timer): Timer {
  return {
    seconds: time.seconds,
    startTime:
      time.startTime && time.seconds
        ? Date.now() - (time.seconds * 1000 - (time.remainingTime || time.seconds * 1000))
        : null,
    endTime: time.endTime ? Date.now() : null,
  };
}

const { actionCreator: sendTime, action: RECEIVE_TIME } = createKeyducer<Timer>("RECEIVE_TIME", normalizeTimer);

export { RECEIVE_TIME, sendTime };
